import axios from 'axios';
import { config } from '../config/config';
import { getAuth } from 'firebase/auth';

const getAuthHeaders = async () => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const paymentService = {
  async initiatePayment(paymentData) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.post(
        `${config.apiUrl}/payments/initiate`, 
        paymentData,
        authConfig
      );
      return response.data;
    } catch (error) {
      console.error('Error initiating payment:', error);
      throw error;
    }
  },

  async createPayment(paymentData) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.post(
        `${config.apiUrl}/payments/create`, 
        paymentData,
        authConfig
      );
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },

  async uploadPaymentScreenshot(formData) {
    try {
      const auth = getAuth();
      const token = await auth.currentUser?.getIdToken();
      
      const response = await axios.post(
        `${config.apiUrl}/payments/validate`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`
            // Don't set Content-Type - let axios set it with boundary
          },
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
          timeout: 60000 // 60 seconds timeout
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading payment screenshot:', error);
      throw error;
    }
  },

  async getPaymentStatus(paymentId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.get(
        `${config.apiUrl}/payments/status/${paymentId}`,
        authConfig
      );
      return response.data;
    } catch (error) {
      console.error('Error getting payment status:', error);
      throw error;
    }
  },

  async getPaymentHistory(userId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.get(
        `${config.apiUrl}/payments/history/${userId}`,
        authConfig
      );
      return response.data;
    } catch (error) {
      console.error('Error getting payment history:', error);
      throw error;
    }
  }
};

export default paymentService; 